import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import { EntityLink } from "scmp-app/components/entity-link";
import type { magazinesStyleArticleMoreOnThisContentItemContent$key } from "scmp-app/queries/__generated__/magazinesStyleArticleMoreOnThisContentItemContent.graphql";

import { Container, Headline } from "./styles";

export type Props = {
  reference: magazinesStyleArticleMoreOnThisContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemMagazinesStyleArticleMoreOnThis = forwardRef<HTMLDivElement, Props>(
  ({ className, reference }, elementReference) => {
    const article = useFragment(
      graphql`
        fragment magazinesStyleArticleMoreOnThisContentItemContent on Content {
          ...entityLink
          ...helpersCheckIsMainTopicContent
          ...hooksContentItemProvidersContent
            @arguments(withCoverImage: true, withCoverImageSize768x768: true, withHeadline: true)
        }
      `,
      reference,
    );
    const providers = useContentItemProviders(article);

    return (
      <Container className={className} ref={elementReference}>
        <EntityLink reference={article}>
          {providers.coverImage({
            responsiveVariants: {
              desktopUp: "size768x768",
              mobileUp: "size768x768",
              tabletUp: "size768x768",
            },
          })}

          <Headline>{providers.headline({ preferSocialHeadline: true })}</Headline>
        </EntityLink>
      </Container>
    );
  },
);

ContentItemMagazinesStyleArticleMoreOnThis.displayName =
  "ContentItemMagazinesStyleArticleMoreOnThis";
